import { Layout as HCSSLayout, UserActionsMenuProps } from "@hcss/layout";
import { Box } from "@mui/material";
import { FC } from "react";
import { useAuth } from "oidc-react";
import { useUserClaims } from "../services/auth";
import { useQueryParam, BooleanParam } from "use-query-params";
import Div100vh from "react-div-100vh";

export const Layout: FC = ({ children }) => {
  const [isIFrame] = useQueryParam("embedded", BooleanParam);
  const auth = useAuth();
  const claims = useUserClaims();
  const userActionsMenu: UserActionsMenuProps = {
    onLogOut: auth.signOutRedirect,
    userInfo: {
      companyName: claims.companyName,
      firstName: claims.firstName,
      lastName: claims.lastName,
    },
  };
  return (
    <Div100vh>
      <HCSSLayout sx={{ height: "100%" }}>
        {!isIFrame && (
          <HCSSLayout.Nav
            brandLabel={
              <>
                <span>HCSS&nbsp;</span>
                <strong>Comments</strong>
              </>
            }
            componentsProps={{
              NavBranding: { homeUrl: `/${window.location.search}` },
            }}
            userActionsMenu={userActionsMenu}
          />
        )}
        <HCSSLayout.Content
          sx={{ bgcolor: ({ palette }) => palette.background.paper }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              height: "100%",
            }}
          >
            {children}
          </Box>
        </HCSSLayout.Content>
      </HCSSLayout>
    </Div100vh>
  );
};
